import { render } from "./OnCheck.vue?vue&type=template&id=6619d3df&scoped=true"
import script from "./OnCheck.vue?vue&type=script&lang=js"
export * from "./OnCheck.vue?vue&type=script&lang=js"

import "./OnCheck.vue?vue&type=style&index=0&id=6619d3df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6619d3df"]])

export default __exports__